'use client';

import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
  showCloseButton?: boolean;
}

export function CommonModal({
  open,
  onOpenChange,
  children,
  className,
  showCloseButton = true,
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          'rounded-lg border-0 bg-transparent p-0 shadow-lg',
          className,
        )}
        showCloseButton={showCloseButton}
        overlayClassName="bg-surface-overlay-sheen-75 backdrop-blur-[16px]"
        onInteractOutside={(e) => {
          // Prevent closing modal when clicking outside
          e.preventDefault();
        }}
        onEscapeKeyDown={(e) => {
          // Prevent closing modal when pressing Escape
          e.preventDefault();
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}

